import Home from "./home.js"
export default Home;